import React, { useState } from 'react';
import { Button } from './ui/button';
import { MessageCircle } from 'lucide-react';
import RegistrationModal from './RegistrationModal';

const CTAButtons = ({ className = '', buttonText = 'Register My Trademark', variant = 'light' }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleChatClick = () => {
    // Open Zendesk chat widget using the correct API
    if (window.zE) {
      try {
        window.zE('webWidget', 'open');
      } catch (error) {
        console.log('Error opening Zendesk chat:', error);
      }
    } else {
      // Fallback if Zendesk hasn't loaded yet
      console.log('Zendesk widget is loading...');
      setTimeout(() => {
        if (window.zE) {
          try {
            window.zE('webWidget', 'open');
          } catch (error) {
            console.log('Error opening Zendesk chat:', error);
          }
        }
      }, 1000);
    }
  };

  // Chat button styling based on background variant
  const chatButtonClass = variant === 'dark' 
    ? "js-chat border-2 border-white text-white hover:bg-white hover:text-emerald-600 px-6 py-2.5 h-11 font-semibold transition-all duration-300"
    : "js-chat border-2 border-emerald-600 text-emerald-600 hover:bg-emerald-50 px-6 py-2.5 h-11 font-semibold";

  return (
    <>
      <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>
        <Button
          onClick={() => setIsModalOpen(true)}
          className="bg-gradient-to-r from-emerald-600 to-emerald-700 hover:from-emerald-700 hover:to-emerald-800 px-6 py-2.5 h-11 font-semibold shadow-lg hover:shadow-xl transition-all"
        >
          {buttonText}
        </Button>
        <Button
          variant="outline"
          onClick={handleChatClick}
          className={chatButtonClass}
        >
          <MessageCircle className="w-4 h-4 mr-2" />
          Chat with Us
        </Button>
      </div>
      <RegistrationModal open={isModalOpen} onOpenChange={setIsModalOpen} />
    </>
  );
};

export default CTAButtons;